import { SkeletonBlock } from './Section.styles'

interface SectionSkeletonProps {
  /** Number of placeholder rows. Pick what makes the reserved height match the real content. */
  rows?: number
  /** Row height in px. */
  rowHeight?: number
}

/**
 * Reserves roughly the section's final height while its data is in flight. Sections
 * resolve at different times, so a mis-sized skeleton shifts everything below it.
 */
export const SectionSkeleton = ({ rows = 3, rowHeight = 20 }: SectionSkeletonProps) => (
  <div aria-hidden="true" data-testid="section-skeleton">
    {Array.from({ length: rows }, (_, i) => (
      <SkeletonBlock key={i} $height={rowHeight} />
    ))}
  </div>
)
